import { render, staticRenderFns } from "./NotificationSummaryPopover.vue?vue&type=template&id=1e7a099e&scoped=true&"
import script from "./NotificationSummaryPopover.vue?vue&type=script&lang=js&"
export * from "./NotificationSummaryPopover.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSummaryPopover.vue?vue&type=style&index=0&id=1e7a099e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7a099e",
  null
  
)

export default component.exports